export enum InventorySource {
  RSG = 'rsg',
  ON_FARM = 'onFarm',
}
